import styled, { css } from 'styled-components'

import { Color } from 'root-constants'

import { IProps as IProgressProps } from './Progress'

const progressValueStyles = (
  color?: string,
  isFastTransition: boolean = false,
) => css`
  background: ${color || Color.GOLD_BASE};
  transition: all ${isFastTransition ? '100ms linear' : '200ms ease-out'};
`

export const StyledProgress = styled.progress<IProgressProps>`
  appearance: none;
  border: none;
  display: block;
  width: 100%;
  height: 100%;
  background: ${({ background }) => background || Color.WHITE};

  &::-webkit-progress-bar {
    background: ${({ background }) => background || Color.WHITE};
  }
  &::-webkit-progress-value {
    ${({ color, isFastTransition }) =>
      progressValueStyles(color, isFastTransition)}

    ${({ roundedAllSides, borderRadius }) =>
      roundedAllSides &&
      css`
        border-radius: ${borderRadius || '999px'};
      `}

    ${({ roundedAllSides, borderRadius }) =>
      !roundedAllSides &&
      borderRadius &&
      css`
        border-bottom-right-radius: ${borderRadius};
        border-top-right-radius: ${borderRadius};
      `}
  }
  &::-moz-progress-bar {
    ${({ color, isFastTransition }) =>
      progressValueStyles(color, isFastTransition)}

    ${({ roundedAllSides, borderRadius }) =>
      roundedAllSides &&
      css`
        border-radius: ${borderRadius || '999px'};
      `}
  }
  &::-ms-fill {
    ${({ color, isFastTransition }) =>
      progressValueStyles(color, isFastTransition)}

    ${({ roundedAllSides, borderRadius }) =>
      roundedAllSides &&
      css`
        border-radius: ${borderRadius || '999px'};
      `}
  }
`
